module.exports = __webpack_public_path__ + "static/media/google-skillshop-white.442c0fcd.svg";